import React from "react";

const TakeTour = () => {
  return (
    <div
      className="bg-cover  min-h-[800px]  flex flex-col md:flex-row items-center justify-center pt-28 md:px-48 px-12  bg-right-bottom"
      style={{ backgroundImage: "url('image/home/map2.jpg')" }}
    >
      {/* Left side image */}
      <div className="w-full md:w-1/2 z-10">
        <img
          src="image/home/ThreeImage.png"
          alt="Left Image"
          className="md:mx-auto md:max-w-sm md:-mr-12"
        />
      </div>

      {/* Right side content */}
      <div className="w-full md:w-1/2  text-left z-10 ">
        <h1 className="text-3xl md:text-4xl  md:ml-28 lg:text-5xl font-bold text-black">
          Take a Tour with Us
        </h1>
        <p className="text-black mt-12 md:text-sm md:ml-28">
          Check out Historic tours and 5 Star hotel bookings packages
        </p>
        <button className="mt-6 px-8 py-3 bg-[#ED8B00] md:ml-28 md:mt-12 text-white font-semibold rounded-lg flex items-center justify-center">
          <span className="mr-2">Button</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3033 10.7799C12.0735 10.7799 11.865 10.6868 11.7141 10.536C11.5633 10.3851 11.4701 10.1766 11.4701 9.94678L11.4701 3.70892L2.28603 12.893C1.96017 13.2189 1.43338 13.2189 1.10752 12.893C0.781663 12.5671 0.781663 12.0403 1.10752 11.7145L10.2916 2.5304L4.05371 2.53038C3.59291 2.53038 3.22054 2.158 3.22054 1.6972C3.22054 1.23641 3.593 0.863942 4.0538 0.863942L12.3034 0.863937C12.7642 0.863937 13.1365 1.23629 13.1365 1.69708L13.1365 9.94666C13.1365 10.4075 12.7641 10.7799 12.3033 10.7799Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TakeTour;
